import Vue from 'vue';
import Vuex from 'vuex';
import { auth } from '@/store/auth.module';
import reservations from '@/store/reservations.module';
import reservationsProducts from '@/store/reservations_products.module';
import reservationsReconcile from '@/store/reservations_reconcile.module';

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== 'production';

export default new Vuex.Store({
  modules: {
    auth,
    reservations,
    reservationsProducts,
    reservationsReconcile,
  },
  strict: debug
});
